import Sidebar from "./Sidebar";
import Footer from "./Footer";
import spektorLogo from "./spektor-logo-w.png";

const PageBody = (props) => {
  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <header className="page-header row">
        <div className="logo-wrapper d-flex align-items-center col-auto">
          <img className="light-logo img-fluid" src={spektorLogo} alt="logo" />
        </div>
      </header>

      <div className="page-body-wrapper pt-5">
        <aside className="page-sidebar">
          <div className="left-arrow" id="left-arrow">
            <i data-feather="arrow-left"></i>
          </div>
          <Sidebar />
          <div className="right-arrow" id="right-arrow">
            <i data-feather="arrow-right"></i>
          </div>
        </aside>

        {props.children}
      </div>
    </div>
  );
};

export default PageBody;
